// extracted by mini-css-extract-plugin
export default {"header":"StudentTrainingModalHeader_header__9fFRe","name":"StudentTrainingModalHeader_name__CTR+v","facts":"StudentTrainingModalHeader_facts__6TmDN"};